const mapsSearch = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

/** Opens directly in Google Maps (desktop & mobile) */
export const JINDAL_TYRE_MAP_URL = mapsSearch(
  "Ramkaran Rajeshkumar Jindal Tyres, 46 Gandhi Grain Market, Telephone Exchange Square, Nagpur 440008"
);

export const MINGGO_MAP_URL = mapsSearch(
  "Minggo Toys and Gift shop, 46 Gandhi Grain Market, Telephone Exchange Square, Nagpur 440008"
);
